"use client";

import { createContext, useContext } from "react";

import type { ProductCardViewModel } from "@/app/components/shared/product-card";
import { breakpoint } from "@/app/utilities/breakpoint";
import type { FilterGroup, FilterRange } from "@/composites/product-listing";

import type { ListingStatus } from "./listing-status";

export const LG_UP = `(min-width: ${breakpoint("lg")})`;

export interface ListingOnward {
	label: string;
	href: string;
}

export interface ListingStateValue {
	groups: FilterGroup[];
	cards: ProductCardViewModel[];
	firstPosition: number;
	total: number;
	isPending: boolean;
	sort: string;
	toggle: (groupId: string, value: string) => void;
	setRange: (groupId: string, range: FilterRange) => void;
	setSort: (sort: string) => void;
	clearAll: () => void;
	loadMore?: () => void;
	isLoadingMore: boolean;
	hasPrevious: boolean;
	loadPrevious?: () => void;
	isLoadingPrevious: boolean;
	pageHref: (page: number) => string;
	/** Below lg, how many of `cards` show. */
	shownBelowLg: number;
	firstNewCard?: number;
	newCardFocused: () => void;
	status: ListingStatus;
	retry: () => void;
	onward: ListingOnward;
}

export const ListingStateContext = createContext<ListingStateValue | null>(
	null
);

export function useListingState(): ListingStateValue {
	const value = useContext(ListingStateContext);
	if (!value) {
		throw new Error(
			"Listing controls must sit inside ListingStateProvider"
		);
	}
	return value;
}

export function useListingTotal(): number {
	return useListingState().total;
}
